import { defineMessages } from 'react-intl';

const messages = defineMessages({
  social: {
    id: 'OKhRC6',
    defaultMessage: 'Share',
  },
  pb_question_1: {
    id: '3/LL6x',
    defaultMessage: 'Securely access',
  },
  pb_question_2: {
    id: '4dHk7U',
    defaultMessage: 'Detect cyberthreats',
  },
  pb_question_3: {
    id: 'lXDHEO',
    defaultMessage: 'Additional requirements',
  },
  pb_question_4: {
    id: 'F8Hz+R',
    defaultMessage: 'Managable devices',
  },
  pb_question_5: {
    id: 'A9KRyV',
    defaultMessage: 'Operating systems',
  },
  facebook: {
    id: '06VF+w',
    defaultMessage: 'Share on Facebook',
  },
  twitter: {
    id: '80Vefc',
    defaultMessage: 'Share on Twitter',
  },
  linkedin: {
    id: 'M4kFT5',
    defaultMessage: 'Share on LinkedIn',
  },
  email: {
    id: '/ukNSg',
    defaultMessage: 'Share via Email',
  },
  welcomeMsg: {
    id: 'Q+U0TW',
    defaultMessage: 'Welcome!',
  },
  personalPlan: {
    id: 'aLPq9c',
    defaultMessage: "What's best for your organization?",
  },
  secondary: {
    id: 'SfkOYl',
    defaultMessage: 'Find your MaaS360 plan',
  },
  landingBtn_text: {
    id: 'W3B7bp',
    defaultMessage: 'Start the assessment',
  },
  pagerResultsBtn_text: {
    id: '4jl5zC',
    defaultMessage: 'View the results',
  },
  order_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  back_text: {
    id: 'xktFGM',
    defaultMessage: 'Back to Assessment',
  },
  restart_text: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  chat_text: {
    id: 'IjD/pk',
    defaultMessage: 'Chat with IBM',
  },
  drawer_close: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  launch_text: {
    id: 'TLc9gR',
    defaultMessage: 'Discover your MaaS360 plan with few simple questions.',
  },
  start_btn_text: {
    id: 'hEFEsa',
    defaultMessage: 'Launch assessment',
  },
  que3_text_desc: {
    id: 'qxgrQW',
    defaultMessage:
      'Do you need to securely access intranet sites or corporate resources on multiple devices?',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  que4_text_desc: {
    id: 'jqhCSn',
    defaultMessage:
      'Do you require functionality of Mobile document editor and/or Mobile document sync?',
  },
  que5_short_desc: {
    id: 'XpBqtj',
    defaultMessage: 'For example: Mobile threat management.',
  },
  que6_text_desc: {
    id: '6sKLeQ',
    defaultMessage:
      'Do you have additional use case requirements for any of the below?',
  },
  que1_text_desc: {
    id: 'vV7Kqd',
    defaultMessage:
      'What use case do you require to manage with MaaS360: Knowledge worker or Frontline device management?',
  },
  que_2_text_desc: {
    id: 'P0HKs+',
    defaultMessage: 'Do you need your devices locked down to a kiosk mode?',
  },
  que_2_text_tooltip: {
    id: 'uQlHcF',
    defaultMessage:
      'Kiosk mode is a security feature that locks down a device to run only a specific application or set of applications, ensuring the device is used solely for its intended purpose.',
  },
  que5_text_desc: {
    id: 'XQ4JZs',
    defaultMessage: 'Do you require Mobile Threat Defense?',
  },
  que5_text_tooltip: {
    id: 'oAloYD',
    defaultMessage:
      'IBM MaaS360 Mobile Threat Defense Professonal helps protect corporate data from advanced mobile threats and provide ITOps and SecOps teams with the integrated tools needed for endpoint management and security. Available as an add-on to any of our MaaS360 pricing plans.',
  },
  que1_text_desc_opt1: {
    id: 'JBCaIp',
    defaultMessage: 'Knowledge worker',
  },
  que1_text_desc_opt1_tooltip: {
    id: '66ydMC',
    defaultMessage:
      'A knowledge worker is a professional who generates value for the organization with their expertise, critical thinking, and interpersonal skills.',
  },
  que1_text_desc_opt2: {
    id: 'tSJ/R3',
    defaultMessage: 'Frontline device management',
  },
  que1_text_desc_opt2_tooltip: {
    id: 'SelYbv',
    defaultMessage:
      ' Frontline device management involves overseeing and optimizing mobile devices used by frontline workers, ensuring they are securely configured, updated and functioning efficiently to support daily tasks and enhance productivity.',
  },
  que6_opt1: {
    id: 'AELmaI',
    defaultMessage: 'Remote access to your devices for troubleshooting',
  },
  que6_opt1_tooltip: {
    id: 'UEjW9O',
    defaultMessage:
      'TeamViewer is a remote desktop access solution that allows maintenance of computers and other devices. Available as an add-on to any of our MaaS360 pricing plans.',
  },
  que6_opt2: {
    id: 'NiVxun',
    defaultMessage: 'Additional IBM Security solutions and/or services',
  },
  que6_opt3: {
    id: 'S8OTDS',
    defaultMessage: 'No additional requirements',
  },
  que6_opt1_short_ans_selec: {
    id: '6ptXs/',
    defaultMessage: 'Remote Access',
  },
  que6_opt2_short_ans_selec: {
    id: 'kt5tlu',
    defaultMessage: 'Extra IBM Security solutions',
  },
  que6_opt3_short_ans_selec: {
    id: 'S8OTDS',
    defaultMessage: 'No additional requirements',
  },
  que7_text_desc: {
    id: 'uZXFZU',
    defaultMessage: 'How many devices would you like to manage?',
  },
  que7_numinput_text: {
    id: 'uXGPY6',
    defaultMessage: 'Please add numbers of devices',
  },
  que7_short_desc: {
    id: 'an/uIK',
    defaultMessage:
      'Laptops, desktops, smartphones, tablet, purpose built devices?',
  },
  que7_opt1: {
    id: 'Htbis6',
    defaultMessage: '1-99',
  },
  que7_opt2: {
    id: 'SRC+KN',
    defaultMessage: '100-500',
  },
  que7_opt3: {
    id: 'MATDbP',
    defaultMessage: '501-1000',
  },
  que7_opt4: {
    id: 'QIAibA',
    defaultMessage: 'more than 1000',
  },
  que8_text_desc: {
    id: 'GMZGs/',
    defaultMessage: 'Which operating system(s) would you like to manage?',
  },
  que8_short_desc: {
    id: 'gSenzY',
    defaultMessage: 'Select all that apply',
  },
  que8_opt1: {
    id: 'XnimdQ',
    defaultMessage: 'Windows',
  },
  que8_opt2: {
    id: 'edqhRc',
    defaultMessage: 'MacOS',
  },
  que8_opt3: {
    id: 'gOkLaP',
    defaultMessage: 'ChromeOS',
  },
  que8_opt4: {
    id: 'OQDKnx',
    defaultMessage: 'iOS',
  },
  que8_opt5: {
    id: 'gQ7kPU',
    defaultMessage: 'Android',
  },
  que8_opt6: {
    id: 'WGOxuS',
    defaultMessage: 'iPadOS',
  },
  que8_opt7: {
    id: '/VnDMl',
    defaultMessage: 'Other',
  },
  start_over: {
    id: 'i4joXC',
    defaultMessage: 'Start Over',
  },
  your_selection: {
    id: 'T4snp2',
    defaultMessage: 'Your Selections',
  },
  start_at: {
    id: 'Flh+ac',
    defaultMessage: 'Starting at ',
  },
  tax_info: {
    id: 'edRicU',
    defaultMessage: 'Price shown excludes any applicable taxes',
  },
  results_heading: {
    id: 'TklhEA',
    defaultMessage: '#1 pick for you',
  },
  other_results_heading: {
    id: 'NsZa5c',
    defaultMessage: 'Other recommendations',
  },
  results_button: {
    id: '6JEGxX',
    defaultMessage: 'Discover your plan',
  },
  start_trial_btn_txt: {
    id: 'FQm0Au',
    defaultMessage: 'Start your free trial',
  },
  enterprise_title: {
    id: 'thabGU',
    defaultMessage: 'MaaS360 Enterprise',
  },
  enterprise_plan: {
    id: 'AjYzeY',
    defaultMessage: 'MaaS360 Enterprise plan',
  },
  enterprise_short_desc: {
    id: '9cKiVH',
    defaultMessage:
      'The Enterprise plan is the ultimate, easy to use UEM SaaS, that addresses all your endpoint management and security needs.',
  },
  enterprise_desc: {
    id: 'i9O+Di',
    defaultMessage:
      'is a broad, easy to use UEM SaaS, that addresses your endpoint management and security needs: built-in threat management with advanced detection and response for threats such as SMS and e-mail phishing, and advanced features such as document management, content management, intranet access, application security and protected network access. MaaS360 Enterprise plan also contains capabilities such as endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built), app management, automated patch management, policy and compliance rules, IAM and AI security insights (automated user risk management scoring, alerts and recommendations)',
  },
  enterprise_icon: {
    id: 'Ox+Z+K',
    defaultMessage: 'Tutorial',
  },
  essentials_title: {
    id: 'i4gdyS',
    defaultMessage: 'MaaS360 Essentials',
  },
  essentials_plan: {
    id: '5aD5Jb',
    defaultMessage: 'MaaS360 Essentials plan',
  },
  essentials_short_desc: {
    id: 'RVln+l',
    defaultMessage:
      'Manage and secure users, smartphones, tablets, laptops and apps, enabled by cognitive insights with Watson.',
  },
  essentials_desc: {
    id: 'MGhP95',
    defaultMessage:
      'covers your foundational needs of a user friendly, reliable UEM SaaS that brings together endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built devices), app management, automated patch management, with cyber threat defense (policy and compliance rules, IAM) and AI security insights (automated user risk management scoring, alerts and recommendations). MaaS360 manages the following OSs: Android, iOS, iPadOS, MacOS, Windows, Chrome OS.',
  },
  essentials_icon: {
    id: 'MCIcVz',
    defaultMessage: 'Quickstart',
  },
  premier_title: {
    id: 'bNdjL4',
    defaultMessage: 'MaaS360 Premier',
  },
  premier_plan: {
    id: 'AQ6rr0',
    defaultMessage: 'MaaS360 Premier plan',
  },
  premier_short_desc: {
    id: '3Axirr',
    defaultMessage:
      'More advanced UEM and AI capabilities, plus content management, intranet access, application security and protected network access.',
  },
  premier_desc: {
    id: 'v7H2lh',
    defaultMessage:
      'addresses your more advanced needs for a UEM SaaS that should also cover content management, intranet access, application security and protected network access. The MaaS360 Premier plan also include capabilities such as endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built), app management, automated patch management cyber threat defense (policy and compliance rules, IAM) and AI security insights (automated user risk management scoring, alerts and recommendations). MaaS360 manages the following OSs: Android, iOS, iPadOS, MacOS, Windows, Chrome OS.',
  },
  premier_icon: {
    id: 'tF9rgX',
    defaultMessage: 'Webinar',
  },
  deluxe_title: {
    id: 'hWv88Z',
    defaultMessage: 'MaaS360 Deluxe',
  },
  deluxe_plan: {
    id: 'HKawiR',
    defaultMessage: 'MaaS360 Deluxe plan',
  },
  deluxe_short_desc: {
    id: 'y5MCc+',
    defaultMessage:
      'Essential UEM capabilities, plus an encrypted corporate email, contacts, calendar, AI chatbot and voice assistant.',
  },
  deluxe_desc: {
    id: 'PPu6WF',
    defaultMessage:
      'covers your needs of a user friendly, reliable UEM software that ads an encrypted corporate email, contacts and calendar and AI chatbot and voice assistant to the  essential capabilities of MaaS360: endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built), app management, automated patch management, cyber threat defense (policy and compliance rules, IAM) and AI security insights (automated user risk management scoring, alerts and recommendations). MaaS360 manages the following OSs:  Android, iOS, iPadOS, MacOS, Windows, Chrome OS.',
  },
  deluxe_icon: {
    id: 'Ox+Z+K',
    defaultMessage: 'Tutorial',
  },
  buy_here_btn: {
    id: 'QYN6ze',
    defaultMessage: 'Buy now on ibm.com',
  },
  buy_now_aws: {
    id: '6oJwp/',
    defaultMessage: 'Buy now on AWS',
  },
  try_maas_btn: {
    id: 'E7ddgJ',
    defaultMessage: 'Try MaaS360 for free',
  },
  free_trial_btn_text: {
    id: 'FQm0Au',
    defaultMessage: 'Start your free trial',
  },
  back_btn: {
    id: 'cyR7Kh',
    defaultMessage: 'Back',
  },
  next_btn: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  close_btn: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  consult_btn: {
    id: 'EcYmHD',
    defaultMessage: 'Schedule a Consult',
  },
  top_match: {
    id: 'KHi0ci',
    defaultMessage: 'Top Match',
  },
  thank_text: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thank_desc: {
    id: 'OYVuiH',
    defaultMessage:
      'We have received your request. An IBM expert will shortly get in touch with you to assist with a Mass360 pricing plan.',
  },
  q1_selec_key: {
    id: 'T1A3fx',
    defaultMessage: 'MaaS360',
  },
  q2_selec_key: {
    id: 'oIFP0l',
    defaultMessage: 'Kiosk mode',
  },
  q3_selec_key: {
    id: 'xI64n3',
    defaultMessage: 'Securely access intranet or devices',
  },
  q5_selec_key: {
    id: 'XcYEp5',
    defaultMessage: 'Mobile Threat Defense',
  },
  q4_selec_key: {
    id: 'yvvdip',
    defaultMessage: 'Functionality of Mobile document',
  },
  q6_selec_key: {
    id: '4IfP+Z',
    defaultMessage: 'Additional use case',
  },
  q7_selec_key: {
    id: 'OlJHP9',
    defaultMessage: 'No. of devices',
  },
  q8_selec_key: {
    id: 't2uvIi',
    defaultMessage: 'Operating System',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: '5z8K6l',
    defaultMessage: 'The MaaS360 estimator is available in',
  },
  localCurrency_text: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: 'ObupdK',
    defaultMessage: 'Stay here',
  },
  ques_text: {
    id: 'kgOBET',
    defaultMessage: 'Question',
  },
  of_text: {
    id: 'C9WGEu',
    defaultMessage: 'of',
  },
  plan_buy_text: {
    id: 'ZQlA2o',
    defaultMessage: 'Please select the plan and click on buy here.',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  return_assessment: {
    id: '/YY0KV',
    defaultMessage: 'Return to assessment',
  },
  request_plan_text: {
    id: 'G5KVyN',
    defaultMessage: 'Please select the plan you would like to request a quote.',
  },
  deluxe: {
    id: 'ocaqXc',
    defaultMessage: 'Deluxe',
  },
  essentials: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  premier: {
    id: 'sVfVAX',
    defaultMessage: 'Premier',
  },
  enterprise: {
    id: 'CDLJ0W',
    defaultMessage: 'Enterprise',
  },
  include: {
    id: 'QNuTcM',
    defaultMessage: 'Recommended add-on/s:',
  },
  mtd: {
    id: 'XYsyHi',
    defaultMessage: 'Mobile Threat Detection',
  },
  remote_access: {
    id: '6ptXs/',
    defaultMessage: 'Remote Access',
  },
});

export default messages;
